// extracted by mini-css-extract-plugin
export var container = "_mj-0";
export var dotAnimation = "_mj-2";
export var dotsLoading = "_mj-1";